export default async function (ctx, inject) {
  const icons = {}
  const getIcon = size => icons[size + 'x' + size] || ''
  inject('icon', getIcon)
}
